/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

import {
  ERR_PROCESSING_REQ,
  SAVE_SUCCESS,
} from '../../../../SharedModules/AppConstants';

export const dispatchGetCodeTableDetails = (data) => ({
  type: actionTypes.GET_CODETABLE_DATA,
  rebateCodeSerchResult: data,
});

export const setParentSelectedRow = (payload) => ({
  type: actionTypes.SELECTED_PARENT_ROW,
  payload,
});

export const setCompareCodeTableData = (payload) => {
  return {
    type: actionTypes.COMPARE_CODETABLE_DATA,
    payload,
  };
};

export const setCodeTableDataLoading = (payload) => {
  return {
    type: actionTypes.CODETABLE_DATA_LOADING,
    payload,
  };
};

export const setCodeTableDataRowSelected = (payload) => {
  return {
    type: actionTypes.CODETABLE_DATA_ROW_SELECTED,
    payload,
  };
};

export const setCodeTableErrorMessage = (payload) => {
  return {
    type: actionTypes.CODE_TABLE_ERROR_MESSAGE,
    payload,
  };
};

export const setCodeTableSuccessMessage = (payload) => {
  return {
    type: actionTypes.CODE_TABLE_SUCCESS_MESSAGE,
    payload,
  };
};

export const setChildCodeValueError = (payload) => {
  return {
    type: actionTypes.CHILD_CODE_VALUE_ERROR,
    payload,
  };
};

export const setDataChangeTried = (payload) => {
  return {
    type: actionTypes.CODE_TABLE_DATA_CHANGE_TRIED,
    payload,
  };
};

export const resetCodeTableStore = () => {
  return {
    type: actionTypes.RESET_CODETABLE_STORE,
  };
};

export const setSelectedParentProtectedInd = (parentProtInd) => {
  return {
    type: actionTypes.SET_SELECTED_PARENT_PROTECTED_IND,
    selectedParentInd: parentProtInd,
  };
};

export const callGetCodeTableDetailsAPI = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_CODETABLE_DATA,
      values
    );
    if (response.data) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const updateCodeTableAPI = async (values) => {
  try {
    await axios.post(serviceEndPoint.UPDATE_CODETABLE_DATA, values);

    return 'Success';
  } catch (e) {
    return null;
  }
};

export const addCodeValueRow = (row, logInUser) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.CodeTableReducer.rebateCodeSerchResult,
    ];

    if (currentData.length > 0) {
      const index = currentData.findIndex(
        (item) => item.codeDomainKey === row.codeDomainKey
      );

      if (index !== -1) {
        if (
          !currentData[index].valuesProtectedInd ||
          currentData[index].valuesProtectedInd === '1'
        ) {
          currentData[index].valuesProtectedInd = '0';
          currentData[index].lastUpdateUserId = logInUser;
        }
        currentData[index].codeValue = [
          {
            codeValueID: {
              codeDomainKey: row.codeDomainKey,
              codeValue: '',
            },
            index:
              (currentData[index] &&
                currentData[index].codeValue &&
                currentData[index].codeValue.length) ||
              0,
            longDescription: '',
            shortDescription: '',
            isNewRecord: true,
            lastUpdateUserId: logInUser,
          },
          ...currentData[index].codeValue,
        ];

        dispatch(dispatchGetCodeTableDetails(currentData));
        dispatch(setCodeTableDataRowSelected(currentData[index]));
      }
    }
  };
};

export const deleteCodeValueRow = (parent, chidlData, logInUser) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.CodeTableReducer.rebateCodeSerchResult,
    ];

    if (currentData.length > 0) {
      const index = currentData.findIndex(
        (item) => item.codeDomainKey === parent.codeDomainKey
      );

      if (index !== -1) {
        let updatedValue = [];
        if (chidlData.isNewRecord) {
          updatedValue = currentData[index].codeValue.filter(
            (item) => item.index !== chidlData.index
          );
        } else {
          updatedValue = currentData[index].codeValue.map((item) => {
            if (item.index === chidlData.index && !item.isNewRecord) {
              return {
                ...item,
                deleteFlag: true,
                lastUpdateUserId: logInUser,
              };
            }
            return { ...item };
          });
        }

        currentData[index].codeValue = updatedValue;

        dispatch(dispatchGetCodeTableDetails(currentData));
        dispatch(setCodeTableDataRowSelected(currentData[index]));
      }
    }
  };
};

export const updateParentUserId = (parentIndex, userId) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.CodeTableReducer.rebateCodeSerchResult,
    ];

    currentData[parentIndex].lastUpdateUserId = userId;

    dispatch(dispatchGetCodeTableDetails(currentData));
    dispatch(setCodeTableDataRowSelected(currentData[parentIndex]));
  };
};

export const updateChildUserId = (parentIndex, childIndex, userId) => {
  return (dispatch, getState) => {
    const currentData = [
      ...getState().sharedState.CodeTableReducer.rebateCodeSerchResult,
    ];

    currentData[parentIndex].codeValue[childIndex].lastUpdateUserId = userId;
    dispatch(dispatchGetCodeTableDetails(currentData));
    dispatch(setCodeTableDataRowSelected(currentData[parentIndex]));
  };
};

export const DummyUpdateAndDelete = () => {
  return (dispatch, getState) => {
    let currentData = [
      ...getState().sharedState.CodeTableReducer.rebateCodeSerchResult,
    ];

    currentData.push({});
    currentData[0].codeValue = [...currentData[0].codeValue, {}];
    dispatch(dispatchGetCodeTableDetails(currentData));
    dispatch(setCodeTableDataRowSelected(currentData[0]));

    currentData = currentData.filter((item) => item.codeDomainKey);
    currentData[0].codeValue = currentData[0].codeValue.filter(
      (item) => item.codeValueID
    );

    dispatch(dispatchGetCodeTableDetails(currentData));
    dispatch(setCodeTableDataRowSelected(currentData[0]));
  };
};

export const getCodeTableDetails = (func) => {
  return async (dispatch) => {
    dispatch(setCodeTableDataLoading(true));
    const response = await callGetCodeTableDetailsAPI({});
    if (response) {
      const newResponse = response.map((item, index) => {
        return {
          ...item,
          index,
          codeValue: item.codeValue.map((innerItem, innderindex) => {
            return { ...innerItem, index: innderindex };
          }),
        };
      });

      dispatch(dispatchGetCodeTableDetails(newResponse));
      dispatch(setCompareCodeTableData(_.cloneDeep(newResponse)));
      dispatch(setCodeTableDataRowSelected(newResponse[0]));
      dispatch(DummyUpdateAndDelete());
      dispatch(setCodeTableErrorMessage(''));
    } else {
      dispatch(dispatchGetCodeTableDetails([]));
      dispatch(setCompareCodeTableData([]));
      dispatch(setCodeTableDataRowSelected(null));
      dispatch(setCodeTableErrorMessage(ERR_PROCESSING_REQ));
    }

    if (func && typeof func === 'function') {
      func();
    } else {
      dispatch(setCodeTableSuccessMessage(''));
    }

    dispatch(setCodeTableDataLoading(false));
  };
};

export const updateCodeTableDetails = (values, func) => {
  return async (dispatch) => {
    const response = await updateCodeTableAPI(values);
    if (response) {
      dispatch(
        getCodeTableDetails(() => {
          if (func) {
            func();
          }

          dispatch(setCodeTableSuccessMessage(SAVE_SUCCESS));
        })
      );
    } else {
      dispatch(setCodeTableSuccessMessage(''));
      dispatch(setCodeTableErrorMessage(ERR_PROCESSING_REQ));
    }
  };
};

export const setDuplicateFound = (data) => ({
  type: actionTypes.CODE_VALUE_DUPLICATE,
  isDuplicate: data,
});

export const clearReduxCodeTablesScreen = () => (dispatch) => {
  dispatch(setDuplicateFound([]));
  dispatch(setCodeTableSuccessMessage(''));
  dispatch(setCodeTableErrorMessage([]));
  dispatch(setCodeTableDataLoading(false));
  dispatch(dispatchGetCodeTableDetails([]));
  dispatch(setCompareCodeTableData([]));
  dispatch(setCodeTableDataRowSelected(null));
  dispatch(setSelectedParentProtectedInd({}));
  dispatch(resetCodeTableStore({}));
  dispatch(setDataChangeTried({}));
};
